import React from 'react'

import './benchmarking.scss'

import T from 'prop-types'

import { withTranslation } from 'react-i18next';
import './localizations'

import { Model, surveyLocalization, SurveyError } from 'survey-core'
import { Survey } from 'survey-react-ui'
import "survey-core/survey.i18n";

import axios from 'axios'

import { registerCustomSelectWidget } from "./registerCustomSelectWidget";

class Benchmarking extends React.Component {
  constructor(props) {
    super(props);

    axios.defaults.headers.common['X-CSRF-TOKEN'] =
      document.querySelector("meta[name='csrf-token']").getAttribute("content");

    const locale = props.locale || 'en';
    const userId = props.userId || 'logged-out';

    const { t, i18n } = this.props;
    i18n.changeLanguage(locale);

    registerCustomSelectWidget(t);

    this.state = {
      t: t,
      locale: locale,
      userId: userId,
      survey: (new Model({})),
      isSurveyPresent: false,
      originalSurvey: {},
      benchmarking: {},
      currentPage: 0,
      openMobileNavigation: false,
      draftNotice: true,
    };

    this.onNavigationActionClick = this.onNavigationActionClick.bind(this);
    this.handleMobileNavigationClick = this.handleMobileNavigationClick.bind(this);

    surveyLocalization.locales["en"].pagePrevText = t("Back");

    surveyLocalization.locales["en"].completeText = t("Submit");
    surveyLocalization.locales["es"].completeText = t("Enviar");

    surveyLocalization.locales["en"].noneItemText = t("None");
    surveyLocalization.locales["es"].noneItemText = t("None");
  }

  componentDidMount() {
    this.loadSurvey();
  }

  loadSurvey = () => {
    const { locale, userId } = this.state;

    const handleSurveyResponse = (response) => {
      const originalSurvey = response.data.data.survey;
      const benchmarking = response.data.data.benchmarking;

      const survey = this.createSurveyModel({ ...surveyDefaults, ...originalSurvey }, locale);

      this.setState({
        survey: survey,
        benchmarking: benchmarking,
        originalSurvey: originalSurvey,
        isSurveyPresent: true
      })
    };

    const handleSurveyDraft = () => {
      try {
        const surveyProgress = localStorage.getItem(`surveyProgress-#${userId}-#${locale}`);
        const surveyPage = localStorage.getItem(`surveyCurrentPage-#${userId}-#${locale}`);
        const originalSurvey = localStorage.getItem(`originalSurvey-#${userId}-#${locale}`);
        const originalBenchmarking = localStorage.getItem(`originalBenchmarking-#${userId}-#${locale}`);

        const parsedOriginalSurvey = JSON.parse(originalSurvey);
        const page = parseInt(surveyPage, 10);
        const results = JSON.parse(surveyProgress);

        const survey = this.createSurveyModel({ ...surveyDefaults, ...parsedOriginalSurvey }, locale);
        survey.currentPageNo = page;
        survey.data = results;

        this.setState({
          survey: survey,
          benchmarking: JSON.parse(originalBenchmarking),
          originalSurvey: parsedOriginalSurvey,
          currentPage: page,
          isSurveyPresent: true
        })
      } catch (e) {
        console.warn("Failed to parse saved survey data", e);
      }
    }

    const surveyProgress = localStorage.getItem(`surveyProgress-#${userId}-#${locale}`);
    if (surveyProgress) {
      handleSurveyDraft()
    } else {
      axios.get(`/${locale}/benchmarking/qa`)
        .then(response => { handleSurveyResponse(response) })
    }
  };

  createSurveyModel = (data, locale) => {
    const survey = new Model(data);

    survey.onCompleting.add((survey, options) => {
      options.allowComplete = false;

      this.handleCompleteBenchmarking(survey);
    });
    survey.onCurrentPageChanging.add((survey, option) => { this.handlePageChanging(survey, option) });
    survey.onCurrentPageChanging.add(() => { window.scrollTo({ top: 0, behavior: 'auto' }) });
    survey.onCurrentPageChanged.add((survey, option) => {
      const notion = document.querySelector(".sv-action-bar .notion");
      if (!notion) return;

      const isLast = survey.isLastPage;
      notion.innerText = isLast ? this.state.t("draft-final-notion") : this.state.t("draft-notion");
    });
    survey.onAfterRenderSurvey.add((survey, option) => { this.handleOnAfterRenderSurvey(survey, option) });
    survey.onAfterRenderQuestion.add((survey, options) => {
      const { question: q, htmlElement } = options;
      const { name, choices } = q;

      if (q.name === 'first_name' || q.name === 'job_title') {
        htmlElement.style.paddingRight = "0px";
        htmlElement.parentElement.style.flex = null;
      }

      if (q.name === 'last_name' || q.name === 'institution_name_in_english') {
        htmlElement.parentElement.style.flex = null;
      }

      if (q.name === 'email') {
        const emailInput = htmlElement.querySelector(`input`);
        if (!emailInput.__emailListenerAdded) {
          emailInput.__emailListenerAdded = true; // avoid double-binding
          emailInput.addEventListener("input", (e) => {
            q.value = e.target.value;
            const pwdQ = survey.getQuestionByName("password");
            if (pwdQ) {
              pwdQ.clearValue();
              pwdQ.parent.removeElement(pwdQ);
            }

            const subsQ   = survey.getQuestionByName("subscription");
            const policyQ = survey.getQuestionByName("policy");
            [subsQ, policyQ].forEach(qq => {
              if (qq && !qq.visible) {
                qq.visible = true;
                qq.clearValue();
              }
            });
            q.clearErrors();
          });
        }
      }

      if (q.getType() !== "checkbox" || !["subscription", "policy"].includes(name)) {
        return;
      }

      const titleEl = htmlElement.querySelector(".sv_q_title");
      if (titleEl) {
        if (name === "policy") {
          titleEl.innerHTML = "";
        } else {
          titleEl.style.display = "none";
        }
      }

      const labelEl = htmlElement.querySelector(".sv_q_checkbox_control_label");
      if (labelEl) {
        labelEl.innerHTML = choices[0].text;
        labelEl.style.fontSize = "14px";
        labelEl.style.fontFamily = "Montserrat";
      }
    });

    survey.locale = locale;
    survey.startTimer();

    return survey
  };

  handleOnAfterRenderSurvey = (survey, option) => {
    const { t } = this.state;
    const footer = option.htmlElement.querySelector(".sv-action-bar");
    if (footer && !footer.querySelector(".notion")) {
      footer.style.display        = "flex";
      footer.style.justifyContent = "center";
      footer.style.alignItems     = "center";
      footer.style.gap            = "16px"; 

      const notion = document.createElement("div");
      notion.className = "notion";
      notion.innerText = t("draft-notion");
      notion.style.fontSize = "12px";
      notion.style.position    = "absolute";
      notion.style.bottom      = "60px";
      notion.style.left        = "45%";
      notion.style.transform   = "translateX(-45%)";
      notion.style.color = "#6F7276";
      notion.style.fontFamily = "Montserrat";


      const isLast = survey.isLastPage;
      notion.innerText = isLast ? t("draft-final-notion") : t("draft-notion");
      footer.insertBefore(notion, footer.firstChild);
    }
  }

  benchmarkingNavigation = () => {
    const { survey } = this.state;

    return (
      <ul>
        {
          survey.visiblePages.map((page, index) => {
            const isPassed = this.checkAllPageQuestionsHasAnswers(page);
            const isCurrent = page.isActive;

            const actionClass =
              (isCurrent === true)
                ? 'current'
                : (isPassed === true)
                  ? 'passed'
                  : 'disabled';

            return (
              <li
                onClick={this.onNavigationActionClick}
                key={index}
                value={index}
                className={"benchmarking-navigation--action " + actionClass}
              >
                <label
                  onClick={this.onNavigationActionClick}
                  value={index}
                  className={"benchmarking-navigation--title " + actionClass}
                >
                  { page.title }
                </label>
              </li>
            )
          })
        }
      </ul>
    )
  };

  checkAllPageQuestionsHasAnswers = (page) => {
    const { survey } = this.state;

    const pageName = page.name;
    const questionsKeys = Object.keys(survey.questionHashes.names).filter((key) => {
      const propertyHash = survey.questionHashes.names[key][0].propertyHash;

      return (
        key.startsWith(pageName) && propertyHash !== undefined &&
          (
            propertyHash.isVisible === true ||
              (propertyHash.isRequired === true && propertyHash.isVisible === undefined)
          )
      )
    });

    if (questionsKeys.length === 0) return false

    return (
      questionsKeys.every((key) => survey.questionHashes.names[key][0].propertyHash.isAnswered === true)
    )
  };

  onNavigationActionClick = (event) => {
    const element = event.target;
    const isDisabled = element.classList.contains('disabled');
    const pageNumber = element.attributes.value.value;

    if (pageNumber !== undefined && isDisabled === false) {
      this.setState({ currentPage: pageNumber });
    }
  };

  hideBenchmarkingNavigation = () => {
    Array.from(document.getElementsByClassName("benchmarking-navigation"))
      .forEach((navigation) => navigation.style.display = "none")
  };

  handleCompleteBenchmarking = (survey) => {
    const { locale, benchmarking, userId, t } = this.state;

    const completeBtn = document.querySelector(".sv_complete_btn");
    if (completeBtn) {
      completeBtn.disabled = true;
      completeBtn.classList.add("sv-btn--disabled");
    }

    axios.post(
      `/${locale}/benchmarking/survey`,
      { benchmarking: { results: survey.data, benchmarking: benchmarking, time_spent: survey.timeSpent } }
    ).then((response) => {
        survey.stopTimer();
        this.hideBenchmarkingNavigation();
        this.setState({ isSurveyPresent: false }); // not survey on page after finish
        localStorage.removeItem(`surveyProgress-#${userId}-#${locale}`);
        localStorage.removeItem(`originalSurvey-#${userId}-#${locale}`);
        localStorage.removeItem(`originalBenchmarking-#${userId}-#${locale}`);
        localStorage.removeItem(`surveyCurrentPage-#${userId}-#${locale}`);
        this.openInNewTab(response.headers.location)
      }).catch((error) => {
        const message = error.response.data.data.message;
        const lastPage = survey.pages[survey.pages.length - 1];
        const accessPanel = lastPage.elements
        .filter(el => el.getType() === "panel")
        .find(p => p.getQuestionByName("email"));

        const requiresPassword = message === "User already exists" || message === "Password is incorrect";
        if (requiresPassword && accessPanel && !survey.getQuestionByName('password')) {
          const password = accessPanel.addNewQuestion("text", "password");
          password.isRequired = true;
          password.inputType = "password";
          password.title = t("Password");
        }
        const emailQ = accessPanel?.getQuestionByName("email");
        const passwordQ = accessPanel?.getQuestionByName("password");

        if (message === "User already exists") {
          emailQ?.clearErrors();
          const subsQ   = survey.getQuestionByName("subscription");
          const policyQ = survey.getQuestionByName("policy");
          [subsQ, policyQ].forEach(q => {
            if (q) {
              q.visible = false;
            }
          });
          subsQ?.clearValue();
          if (policyQ) { policyQ.value = [policyQ.choices[0].value]; }
          if (passwordQ) {
            passwordQ.visible = true;
          }
          emailQ?.addError(new SurveyError(t("existing-user-error")));
        }

        if (message === "Email is invalid") {
          emailQ?.clearErrors();
          emailQ?.addError(new SurveyError(t("invalid-email-error")));
          if (passwordQ) {
            passwordQ.visible = false;
            passwordQ.clearErrors();
            passwordQ.clearValue();
          }
        }

        if (message === "Password is incorrect") {
          if (passwordQ) {
            passwordQ.visible = true;
            passwordQ.clearErrors();
            passwordQ.addError(new SurveyError(t("password-error")));
          }
        }

        if (completeBtn) {
          completeBtn.disabled = false;
          completeBtn.classList.remove("sv-btn--disabled");
        }
      });
  };

  openInNewTab = (url) => {
    const newWindow = window.open(url, '_self');
    if (newWindow) newWindow.opener = null
  };

  handlePageChanging = (survey, option) => {
    const { currentPage } = this.state;

    if (currentPage !== option.newCurrentPage) {
      this.setState({ currentPage: option.newCurrentPage });

      if (Object.keys(survey.data).length > 0) {
        this.saveOnDraft(survey, this.state.benchmarking, this.state.originalSurvey);
      }
    }
  };

  saveOnDraft = (survey, benchmarking, originalSurvey) => {
    const { userId, locale } = this.state;
    const currentPageIndex = survey.currentPageNo + 1;

    localStorage.setItem(`surveyProgress-#${userId}-#${locale}`, JSON.stringify(survey.data));
    localStorage.setItem(`originalSurvey-#${userId}-#${locale}`, JSON.stringify(originalSurvey));
    localStorage.setItem(`originalBenchmarking-#${userId}-#${locale}`, JSON.stringify(benchmarking));
    localStorage.setItem(`surveyCurrentPage-#${userId}-#${locale}`, currentPageIndex);
  };

  handleMobileNavigationClick = (event) => {
    const { openMobileNavigation } = this.state;

    this.setState({ openMobileNavigation: !openMobileNavigation })
  };

  MobileNavigation = () => {
    const { openMobileNavigation, survey, t } = this.state;

    return (
      <div className={
        `benchmarking-navigation--container-mobile ${openMobileNavigation ? 'open' : 'close'} | u-hide-above@medium`
      }
      >
        <div className="buffer" />

        <button type="button" className="benchmarking-navigation--dropdown-button"
                onClick={this.handleMobileNavigationClick}
        >
          <span className="pageNumber">{t("Page")} {survey.currentPageNo + 1} {t("of")} {survey.pageCount + 1}</span>
          <span className="menu">
            {t("All steps")}
            <span className="arrow" />
          </span>
        </button>


        <div
            className="benchmarking-navigation benchmarking-navigation--dropdown | u-position-relative c-bookend-item"
            style={{display: openMobileNavigation ? 'block' : 'none'}}
        >
          {this.benchmarkingNavigation()}
        </div>
      </div>
    )
  };

  Navigation = () => {
    return (
      <div className="benchmarking-navigation u-position-relative c-bookend-item left | u-hide-below@medium">
      {this.benchmarkingNavigation()}
    </div>
    )
  };

  render() {
    const { survey, isSurveyPresent, currentPage} = this.state;

    survey.currentPageNo = currentPage;

    return (
        isSurveyPresent && (
          <div>
            {this.MobileNavigation()}
            <div className="benchmarking-container u-display-flex c-bookend horizontal">
              {this.Navigation()}

              <div className="benchmarking-content u-position-relative c-bookend-item right">
                <Survey model={survey}/>
              </div>
            </div>
          </div>
        )
    );
  }
}

const surveyDefaults = {
  showQuestionNumbers: 'off',
  questionTitlePattern: 'numTitle',
};

Benchmarking.propTypes = {
  locale: T.string,
};

export default withTranslation()(Benchmarking);
